import { render, staticRenderFns } from "./ParkingAdmin.vue?vue&type=template&id=15521ade&scoped=true"
import script from "./ParkingAdmin.vue?vue&type=script&lang=js"
export * from "./ParkingAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15521ade",
  null
  
)

export default component.exports